import Config from '@config';
import { ReferenceBook } from '@gasbi/shared';

import { injectSupplySlice } from '@/app/supplyApi';
import { FiltersGrid, Pagination } from '@/features/types';
import {
  infiniteQueryOptions,
  normalizeInfiniteQueryData,
} from '@/features/utils';

const api = injectSupplySlice({
  baseUrl: `${Config.VITE_API_URL}/industries`,
  tagTypes: ['Industry'],
  endpoints: builder => ({
    getIndustries: builder.query<ReferenceBook[], void>({
      query: () => ({ url: '', method: 'GET' }),
      providesTags: () => ['Industry'],
    }),
    getIndustriesI: builder.infiniteQuery<
      ReferenceBook[],
      FiltersGrid,
      Pagination
    >({
      infiniteQueryOptions,
      query: ({ queryArg, pageParam }) => ({
        url: '/query',
        method: 'GET',
        params: { ...queryArg, ...pageParam },
      }),
      providesTags: () => ['Industry'],
    }),
    getIndustryById: builder.query<ReferenceBook, string>({
      query: id => ({ url: `/${id}`, method: 'GET' }),
      providesTags: (_result, _error, id) => [{ type: 'Industry', id }],
    }),
    createIndustry: builder.mutation<string, Pick<ReferenceBook, 'value'>>({
      query: data => ({ url: '', method: 'POST', data }),
      invalidatesTags: ['Industry'],
    }),
    updateIndustry: builder.mutation<
      void,
      { id: string; data: Omit<ReferenceBook, 'id'> }
    >({
      query: ({ id, data }) => ({ url: `/${id}`, method: 'PUT', data }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: 'Industry', id },
        'Industry',
      ],
    }),
  }),
});

export const industriesApi = api;

export const {
  useGetIndustriesQuery,
  useGetIndustryByIdQuery,
  useCreateIndustryMutation,
  useUpdateIndustryMutation,
} = api;

export const useGetIndustriesInfiniteQuery = normalizeInfiniteQueryData(
  api.useGetIndustriesIInfiniteQuery,
);
